export { Page_EventDetail } from "./Detail";
